/* Sondur Travel — comportamento das páginas Replo da referência, reconstruído nativo (sem o runtime do Replo).
   Carrossel (setas, pontinhos, miniaturas ligadas), acordeão (collapsible) e botões que navegam. */
(function () {
  'use strict';
  var CLS = { navDisabled: 'r-1wnl70w', dotActive: 'r-6t04g1', thumbTarget: 'r-ddplcp' };

  // por página: o runtime do Replo troca a variável por faixa de tela (desktop > 1024 · tablet 641-1024 · celular <= 640);
  // medido na referência: 3 no desktop e 1 no celular para o carrossel de avaliações (tablet: metade, arredondado).
  function perPage(track) {
    if (track._sdPP === undefined) track._sdPP = Math.max(1, Math.round(parseFloat(track.style.getPropertyValue('--replo-carousel-slides-per-page')) || 1));
    var d = track._sdPP, w = window.innerWidth;
    var v = w <= 640 ? 1 : (w <= 1024 ? Math.max(1, Math.round(d / 2)) : d);
    if (d > 1) track.style.setProperty('--replo-carousel-slides-per-page', String(v));
    return v;
  }
  function slidesOf(track) {
    return [].filter.call(track.children, function (c) { return c.getAttribute('data-replo-part') === 'slide'; });
  }
  function offsetOf(track, i) {
    var s = slidesOf(track); if (!s.length) return 0;
    var gap = parseFloat(getComputedStyle(track).gap) || 0;
    var w = s[0].getBoundingClientRect().width;
    return Math.round((w + gap) * i);
  }
  function move(track, i, animar) {
    var x = -offsetOf(track, i);
    if (animar) {
      track.style.transitionDuration = '250ms'; track.style.transitionProperty = 'transform'; track.style.transitionTimingFunction = 'ease';
      clearTimeout(track._sdT);
      track._sdT = setTimeout(function () { track.style.transitionDuration = '0ms'; track.style.transitionProperty = 'none'; track.style.transitionTimingFunction = ''; }, 260);
    }
    track.style.transform = 'translate3d(' + x + 'px, 0px, 0px)';
  }

  function Carousel(root) {
    var tracks = [].slice.call(root.querySelectorAll('[data-replo-part="slide-track"]'));
    if (!tracks.length) return;
    var main = tracks[0], thumbs = tracks[1] || null;
    var slides = slidesOf(main), n = slides.length;
    var prev = root.querySelector('button[data-direction="previous"]');
    var next = root.querySelector('button[data-direction="next"]');
    var dots = [].slice.call(root.querySelectorAll('[aria-label^="Go to slide"]'));
    var sr = root.querySelector('.replo-sr-only');
    var idx = 0;
    slides.forEach(function (s, i) { if (s.getAttribute('data-is-active') === 'true') idx = i; });

    function navState(btn, off) {
      if (!btn) return;
      if (off) { btn.setAttribute('disabled', ''); btn.classList.add(CLS.navDisabled); }
      else { btn.removeAttribute('disabled'); btn.classList.remove(CLS.navDisabled); }
    }
    function render(animar) {
      var pp = perPage(main), max = Math.max(0, n - pp);
      if (idx > max) idx = max; if (idx < 0) idx = 0;
      move(main, idx, animar);
      slides.forEach(function (s, i) {
        var on = i >= idx && i < idx + pp;
        if (i === idx) { s.setAttribute('data-is-active', 'true'); s.setAttribute('data-is-target', 'true'); }
        else { s.removeAttribute('data-is-active'); s.removeAttribute('data-is-target'); }
        if (on) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
      });
      navState(prev, idx <= 0); navState(next, idx >= max);
      dots.forEach(function (d, i) {
        var on = i === idx; d.setAttribute('aria-current', on ? 'true' : 'false');
        if (on) d.classList.add(CLS.dotActive); else d.classList.remove(CLS.dotActive);
      });
      if (thumbs) {
        var ts = slidesOf(thumbs);
        ts.forEach(function (t, i) {
          var box = t.firstElementChild;
          if (i === idx) { t.setAttribute('data-is-target', 'true'); t.setAttribute('data-is-active', 'true'); if (box) box.classList.add(CLS.thumbTarget); }
          else { t.removeAttribute('data-is-target'); t.removeAttribute('data-is-active'); if (box) box.classList.remove(CLS.thumbTarget); }
        });
        var tpp = Math.max(1, Math.floor(thumbs.parentElement.getBoundingClientRect().width / (ts[0] ? ts[0].getBoundingClientRect().width : 1)));
        move(thumbs, Math.min(idx, Math.max(0, ts.length - tpp)), animar);
      }
      if (sr) sr.textContent = 'Slide ' + (idx + 1) + ' of ' + n;
    }
    function go(i, animar) { idx = i; render(animar !== false); }
    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); if (idx > 0) go(idx - 1); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); go(idx + 1); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); d.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(i); } }); });
    if (thumbs) slidesOf(thumbs).forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
    // arrasto / deslize (toque e mouse) na faixa principal
    var x0 = null, dx = 0;
    var viewport = main.parentElement;
    viewport.addEventListener('pointerdown', function (e) { x0 = e.clientX; dx = 0; });
    viewport.addEventListener('pointermove', function (e) { if (x0 !== null) dx = e.clientX - x0; });
    function fim() { if (x0 === null) return; if (dx < -40) go(idx + 1); else if (dx > 40 && idx > 0) go(idx - 1); x0 = null; dx = 0; }
    viewport.addEventListener('pointerup', fim); viewport.addEventListener('pointercancel', fim);
    var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { render(false); }, 120); });
    render(false);
  }

  function Collapsibles(group) {
    var itens = [].slice.call(group.querySelectorAll('[data-replo-collapsible]'));
    function set(it, aberto) {
      var trig = it.querySelector('[role="button"]'); var body = trig && trig.nextElementSibling;
      it.setAttribute('data-state', aberto ? 'open' : 'closed');
      if (trig) trig.setAttribute('aria-expanded', aberto ? 'true' : 'false');
      if (body) { if (aberto) body.removeAttribute('hidden'); else body.setAttribute('hidden', ''); }
    }
    itens.forEach(function (it) {
      var trig = it.querySelector('[role="button"]'); if (!trig) return;
      function toggle(e) {
        if (e) e.preventDefault();
        var aberto = it.getAttribute('data-state') === 'open';
        itens.forEach(function (o) { if (o !== it) set(o, false); });   // acordeão: um aberto por vez, como na referência
        set(it, !aberto);
      }
      trig.addEventListener('click', toggle);
      trig.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') toggle(e); });
    });
  }

  function init() {
    [].forEach.call(document.querySelectorAll('[data-replo-carousel]'), function (r) { if (!r._sdC) { r._sdC = 1; Carousel(r); } });
    var grupos = [].slice.call(document.querySelectorAll('[data-orientation="vertical"]:not([data-replo-collapsible])'));
    if (!grupos.length) grupos = [document];
    grupos.forEach(function (g) { if (!g._sdA) { g._sdA = 1; Collapsibles(g); } });
    [].forEach.call(document.querySelectorAll('[data-sd-href]'), function (b) {
      if (b._sdH) return; b._sdH = 1;
      b.addEventListener('click', function (e) { e.preventDefault(); window.location.href = b.getAttribute('data-sd-href'); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.sdReploInit = init;
})();
